// TODO: Replace these placeholder imports with actual measure images
// For now, using placeholder paths - add actual PNG files for each measure type

import airAirHeatPumpImg from './air-air-heatpump.png'
import airWaterHeatPumpImg from './air-water-heatpump.png'
import basementCeilingImg from './basement-ceiling.png'
import basementExteriorWallImg from './basement-exterior-wall.png'
import blowInInsulationImg from './blow-in-insulation.png'
import districtHeatingImg from './district-heating.png'
import doorImg from './door.png'
import exteriorWallETICSImg from './exterior-wall-etics.png'
import floorPlateImg from './floor-plate.png'
import groundSourceHeatPump from './ground-source-heatpump.png'
import pelletHeatingImg from './pellet-heating.png'
import roofWindowsImg from './roof-windows.png'
import roofImg from './roof.png'
import topFloorCeilingImg from './top-floor-ceiling.png'
import ventilationImg from './ventilation.png'
import windowsImg from './windows.png'

export const measureImages = {
  exteriorWallETICS: exteriorWallETICSImg,
  airWaterHeatPump: airWaterHeatPumpImg,
  airAirHeatPump: airAirHeatPumpImg,
  groundSourceHeatPump: groundSourceHeatPump,
  pelletHeating: pelletHeatingImg,
  windows: windowsImg,
  roofWindows: roofWindowsImg,
  door: doorImg,
  basementExteriorWall: basementExteriorWallImg,
  basementCeiling: basementCeilingImg,
  roof: roofImg,
  topFloorCeiling: topFloorCeilingImg,
  floorPlate: floorPlateImg,
  decentralVentilation: ventilationImg,
  blowInInsulation: blowInInsulationImg,
  districtHeating: districtHeatingImg,
} as const

export type MeasureImageKey = keyof typeof measureImages
